import React, { useEffect, useState } from "react";
import Header from "./Header";
import { AppSidebar } from "./Sidebar";
import AppRoutes from "./AppRoutes";
import { useLocation, useNavigate } from "react-router-dom";

const AppLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedOption, setSelectedOption] = useState(
    sessionStorage.getItem("selectedOption") || "PolicyCheck"
  );

  useEffect(() => {
    sessionStorage.setItem("selectedOption", selectedOption);
  }, [selectedOption, location, navigate]);

  const canRenderHeaderSection = () => {
  if (
    !(
      location?.pathname?.toLowerCase() === "/csrview" ||
      location?.pathname?.toLowerCase() === "/csrsheet" ||
      location.pathname === "/xlpage" ||
      location.pathname === "/AccessDenied" ||
      location.pathname === "/UnAuthorizedUser" ||
      location.pathname === "/Warning" ||
      location.pathname === "/qcJob" ||
      location?.pathname === "/TimeoutError" ||
      location?.pathname === "/DispatchedJob" ||
      location?.pathname?.toLowerCase() === "/csrquotecompare" ||
      location?.pathname?.toLowerCase().includes("/createproposalbuilder") ||
      location?.pathname?.toLowerCase().includes("/proposalsections")
    )
  ) {
    return true;
  }
  return false;
};

  const canRenderSideBar = () => {
    if (
      location?.pathname?.toLowerCase()  === "/csrview" ||
      location?.pathname?.toLowerCase()  === "/csrsheet" ||
      location.pathname === "/AccessDenied" ||
      location?.pathname === "/UnAuthorizedUser" ||
      location?.pathname === "/TimeoutError" ||
      location?.pathname === "/DispatchedJob" ||
      location?.pathname?.toLowerCase() === "/csrquotecompare" ||
      location?.pathname?.toLowerCase().includes("/createproposalbuilder") ||
      location?.pathname?.toLowerCase().includes("/proposalsections") 
    ) {
      return false;
    }
    return true;
  };
  return (
    <div>
      {canRenderHeaderSection() && (
        <div className="header-container">
          <div className="left-content">
            <div className="logo-container">
              <img
                src='ExdioniSTUDIOLogo.png'
                alt="Exdion iSTUDIO Logo"
                className="header-logo"
              />
            </div>
            <div className="welcome-text">
              Welcome To Exdion
            </div>
          </div>
          {/* {["ramu_s@exdioninsurance.com"]?.includes(sessionStorage?.getItem('userName')?.toLowerCase()) ? <Header
            setSelectedOption={setSelectedOption}
          /> : null} */}
          <Header setSelectedOption={setSelectedOption} />
        </div>
      )}
      <div className="app-container">
        {canRenderSideBar() && (
          <div>
            <AppSidebar selectedOption={selectedOption} />
          </div>
        )}
        <div style={{ width: "100%" }}>
          <AppRoutes selectedOption={selectedOption} />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
